import categoriesApi from '../_api'
import i18n from '@/locales/'

export default {
  fetchCategories: async (
    { getters, commit, dispatch },
    pagination = false
  ) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      const page = getters.currentPage
      const filters = getters.filters
      const response = await categoriesApi.getDefaultCategories(
        page,
        pagination,
        filters
      )
      commit('setCategories', response.data)
      commit('setCategoriesLastPage', response.headers['pagination-last-page'])
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'categories_action_fetch_categories_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCategories', false)
    }
  },
  fetchCustomCategories: async (
    { getters, commit, dispatch },
    pagination = false
  ) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      const page = getters.currentPage
      const filters = getters.filters
      const response = await categoriesApi.getCustomCategories(
        page,
        pagination,
        filters
      )
      commit('setCustomCategories', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'categories_action_fetch_categories_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCategories', false)
    }
  },
  fetchDefaultCategoriesOffice: async (
    { getters, commit, dispatch },
    pagination = false
  ) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      const page = getters.currentPage
      const filters = getters.filters
      const response = await categoriesApi.getDefaultCategoriesOffice(
        page,
        pagination,
        filters
      )

      commit('setDefaultCategoriesOffice', response.data)
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'categories_action_fetch_categories_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCategories', false)
    }
  },
  fetchUserRecentCategories: async ({ commit, getters }, userId) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      if (!userId) return
      const response = await categoriesApi.getLastUsedUserCategories(userId)
      commit('setUserRecentCategories', response.data)
    } catch (error) {
      console.error(error)
    } finally {
      commit('setIsCallingCategories', false)
    }
   },
  setCategoriesFilters: async ({ commit, dispatch }, filters) => {
    commit('setCategoriesFilters', filters)
    await dispatch('fetchCategories')
  },
  nextCategoriesPage: ({ commit, dispatch, getters }) => {
    if (getters.isCallingCategories) return
    commit('incrementCategoriesCurrentPage')
    dispatch('fetchCategories')
  },
  createCategory: async ({ getters, commit, dispatch }, categoryData) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      const response = await categoriesApi.createDefaultCategoryOffice(categoryData)
      commit('addCategory', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_details_new_category_action_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'company_details_new_category_action_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCategories', false)
    }
  },
  updateCategory: async (
    { getters, commit, dispatch },
    { id, data }
  ) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
     const response = await categoriesApi.updateDefaultCategory(id, data)
     commit('updateCategory', response.data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_details_action_update_custom_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'company_details_action_update_custom_category_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCategories', false)
    }
  },
  removeCategory: async ({ getters, commit, dispatch }, categoryId) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      await categoriesApi.deleteDefaultCategoryOffice(categoryId)
      commit('removeCategory', categoryId)
       dispatch(
         'SnackBars/addSuccess',
         i18n.t('company_details_action_update_custom_category_success'),
         { root: true }
       )
     } catch (error) {
       dispatch(
         'SnackBars/addErrorHandler',
         {
           error: error,
           errorMessage: 'company_details_action_update_custom_category_error'
         },
         { root: true }
       )
     } finally {
       commit('setIsCallingCategories', false)
     }
  },

  createCustomSubcategory: async (
    { getters, commit, dispatch },
    { categoryId, data }
  ) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      const response = await categoriesApi.createCustomSubcategory(categoryId, data)

      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_details_action_create_custom_category_success'),
        { root: true }
      )
      commit('addSubCategory', response.data)
    } catch (error) {
      console.error(error)
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'company_details_action_create_custom_category_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCategories', false)
    }
  },
  updateCustomSubcategory: async (
    { getters, commit, dispatch },
    { id, data }
  ) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      await categoriesApi.updateCustomSubcategory(id, data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_details_action_update_custom_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'company_details_action_update_custom_category_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCategories', false)
    }
  },
  deleteCustomSubcategory: async ({ getters, commit, dispatch }, subcategory) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      await categoriesApi.deleteCustomSubcategory(subcategory.id)
      commit('removeSubcategory', subcategory)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_details_action_delete_custom_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'company_details_action_update_custom_category_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCategories', false)
    }
  },
  updateDefaultCategory: async (
    { getters, commit, dispatch },
    { id, data }
  ) => {
    if (getters.isCallingCategories) return
    commit('setIsCallingCategories', true)
    try {
      await categoriesApi.updateDefaultCategory(id, data)
      dispatch(
        'SnackBars/addSuccess',
        i18n.t('company_details_action_update_default_category_success'),
        { root: true }
      )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        {
          error: error,
          errorMessage: 'company_details_action_update_default_category_error'
        },
        { root: true }
      )
    } finally {
      commit('setIsCallingCategories', false)
    }
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
